<script lang="ts" setup>
import { ref, Ref } from 'vue'
import { useDialogPluginComponent, Notify } from 'quasar'
import { GeneratedDocument } from '@/models/files/GeneratedDocument'
import { useApi } from '@/store/useAppStore'
import UserApi from '@/services/api/core/UserApi'
import BaseInput from '@/components/base/BaseInput.vue'
import BaseDialog from '@/components/base/BaseDialog.vue'

interface Props {
  selectedFile: GeneratedDocument
  documentName?: string
}
const props = withDefaults(defineProps<Props>(), {
  documentName: '',
})

const emit = defineEmits([...useDialogPluginComponent.emits])

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const userApi: UserApi = useApi()
const newDocumentName: Ref<string> = ref(props.selectedFile.name)
const isLoading: Ref<boolean> = ref(false)

async function renameFile() {
  if (props.selectedFile) {
    try {
      isLoading.value = true
      await userApi.renameTaskDocument(props.selectedFile.id, newDocumentName.value)
      isLoading.value = false
      Notify.create({
        message: 'Document renommé',
        type: 'primary',
      })
      emit('ok', newDocumentName.value)
    } catch (e) {
      dialogRef.value?.hide()
      isLoading.value = false
      Notify.create({
        message: 'Une erreur est survenue lors du renommage du document',
        type: 'negative',
      })
    }
  }
}
</script>
<template>
  <q-dialog ref="dialogRef">
    <BaseDialog
      title="Renommer le document"
      :is-dialog-loading="isLoading"
      @on-dialog-cancel="onDialogCancel()"
      @hide="onDialogHide()"
    >
      <template #body>
        <BaseInput v-model="newDocumentName" type="text" label="Nom du document"> </BaseInput>
      </template>
      <template #actions>
        <q-btn flat label="Renommer" @click="renameFile()" color="primary" :disable="newDocumentName === ''" />
      </template>
    </BaseDialog>
  </q-dialog>
</template>
<style lang="scss" scoped></style>
